import "./styles.css";
import { useEffect, useState } from "react";

import { Sidebar } from "./components/Sidebar";
import { Hero } from "./components/warehouse/Hero";
import { About } from "./components/warehouse/About";
import { Modules } from "./components/warehouse/Modules";
import { Features } from "./components/warehouse/Features";

import { Products } from "./components/Products";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { WhatsAppButton } from "./components/WhatsAppButton";

// import { Hero } from './components/Hero';
import { Navbar } from "./components/Navbar";
import { DukareeFeatures } from "./components/dukaree/DukareeFeatures";
import { DukareeModules } from "./components/dukaree/DukareeModules";

export default function DukareeApp() {
  const [darkMode, setDarkMode] = useState(false);
  useEffect(() => {
    document.title = "Ethos Tech Hub Limited";
  }, []);

  return (
    <div className={`bg-gray-100 min-h-screen ${darkMode ? "dark" : ""}`}>
      <Navbar />
      <Hero />
      <About />

      {/* <div className="relative w-full max-w-4xl mx-auto my-2 py-2">
        <div className="lg:col-span-1">
          <Modules />
        </div>
      </div> */}

      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-1 gap-6 px-6 mt-12">
        <div className="lg:col-span-1">
          <Features />
        </div>
      </div>

      <Contact />
      <Footer />
      {/* <WhatsAppButton /> */}
    </div>
  );
}
